import StatusChip from '../../../components/StatusChip';
import {
  OVERALL_BUSINESS_PROFILE_STATUS_COLORS,
  OVERALL_BUSINESS_PROFILE_STATUS_LABELS,
} from '../../../constants/businessProfileStatusConstants';

const BusinessProfileTableStatusChip = ({ status, size = 'small', variant = 'filled', className, sx }) => {
  const label = OVERALL_BUSINESS_PROFILE_STATUS_LABELS[status];
  const color = OVERALL_BUSINESS_PROFILE_STATUS_COLORS[status];

  if (!label || !color) {
    console.warn(`Unknown status: ${status}`);
    return null;
  }

  return <StatusChip color={color} label={label} size={size} variant={variant} className={className} sx={sx} />;
};

export default BusinessProfileTableStatusChip;
